
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ConvertToWIPDialog extends _Ext.TransDialog<ConvertToWIPRow, any> {
        protected getFormKey() { return ConvertToWIPForm.formKey; }
        protected getIdProperty() { return ConvertToWIPRow.idProperty; }
        protected getLocalTextPrefix() { return ConvertToWIPRow.localTextPrefix; }
        protected getNameProperty() { return ConvertToWIPRow.nameProperty; }
        protected getService() { return ConvertToWIPService.baseUrl; }
        protected getDeletePermission() { return ConvertToWIPRow.deletePermission; }
        protected getInsertPermission() { return ConvertToWIPRow.insertPermission; }
        protected getUpdatePermission() { return ConvertToWIPRow.updatePermission; }

        protected useViewMode() { return true; }
        public form = new ConvertToWIPForm(this.idPrefix);
        statement: string;
        static image: string;
        contractTotals: string;
        TaxArray: any[];
        public Closing: boolean;
        _lookupitems: any[];
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.SubBagNo);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.ExchRate);
            // q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300); 
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);

            //To Show Image on Right Top & Hide Categories 
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);

            //q.setGridEditorHeight(this.form.TaxDetails.element, 150);
            q.hideEditorTab
             
            this.form.DepartmentId.changeSelect2(e => {
                this.setbagnolookup();


            });
            this.form.ProcessId.changeSelect2(e => {
                this.setbagnolookup();


            });
            //Load Image after Row in Details is Clicked
            var _this = this;
            //this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

            //    var x: Serenity.UploadedFile = {
            //        Filename: ConvertToWIPDialog.image,
            //        OriginalName: ""
            //    }
            //    _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

            //    //Set Image Width & Height

            //    q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            //});
            this.form.BagNo.changeSelect2(e => {
                var bagno = this.form.BagNo.value;
                var _subbagno = this._lookupitems.filter(x => x.BagNo == bagno)[0].SubBagNo;
                var lineno = this._lookupitems.filter(x => x.BagNo == bagno)[0].LineNo;
                this.form.SubBagNo.value = parseInt(_subbagno);
                this.form.Line_No.value = lineno;
            })


            this.form.GrossAmount.addValidationRule(this.uniqueName, x => {
                var items = this.form.ItemDetails.getItems();
 
                if (items.length <= 0)
                    return "Select at least one item";

            });

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            this.validateForm();

        }
        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) { 
                    var grid = Production.WIPMovementSelectGrid;

                var filters: _Ext.SelectGridFilters = {
                    DepartmentId:parseInt( this.form.DepartmentId.value),
                        ProcessId: parseInt(this.form.ProcessId.value)
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: Production.WIPMovementRow[]) => {
                        let Item = selectedItems.shift();
                        this.form.BagNo.value = selectedItems[0].BagNo;
                        this.form.SubBagNo.value = selectedItems[0].SubBagNo;
                        this.form.Line_No.value = selectedItems[0].Line_No.toString();
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            
        }
        onDialogClose() {
            this.Closing = true;

        }
        setbagnolookup() {
            var deptid = parseInt(this.form.DepartmentId.value);
            var processid = parseInt(this.form.ProcessId.value);
            let bagnos;

            var lookupitems = [];
            Production.WIPMovementSelectService.List({ DepartmentId: deptid, ProcessId: processid },
                response => {
                    bagnos = response.Entities;
                    this._lookupitems = bagnos;
                    for (var i = 0; i < bagnos.length; i++) {
                        var newlookupitem: Serenity.Select2Item = {
                            id: bagnos[i].BagNo,
                            text: bagnos[i].BagNo
                        };
                        lookupitems.push(newlookupitem);
                    }

                    this.form.BagNo.items = [];
                    this.form.BagNo.items = lookupitems;
                }, { async: false })
        }

       


        protected onDialogOpen() {
            super.onDialogOpen(); 

        }
       
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Invoice',
                cssClass: 'export-pdf-button',
                reportKey: 'Reports.ConvertToWIP',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));

            var postingpermission = Q.Authorization.hasPermission('Inventory:ConvertToWIP:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    ConvertToWIPService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )

            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ConvertToWIPService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
         
    }
}